type TerraConfigKey = `NEXT_PUBLIC_${string}`;
type TerraConfigProvider = (key: TerraConfigKey) => string | undefined;

let provider: TerraConfigProvider | null = null;

function isConfigPlaceholder({
  key,
  value,
}: {
  key: TerraConfigKey;
  value: string | undefined;
}): boolean {
  return value === key || value === `_${key}`;
}

function normalizeConfigValue({
  key,
  value,
}: {
  key: TerraConfigKey;
  value: string | undefined;
}): string | undefined {
  if (isConfigPlaceholder({ key, value })) {
    return undefined;
  }

  return value;
}

export function getTerraConfigValue(key: TerraConfigKey): string | undefined {
  const providerValue = normalizeConfigValue({
    key,
    value: provider?.(key),
  });
  if (providerValue !== undefined) {
    return providerValue;
  }

  const envValue = normalizeConfigValue({
    key,
    value: process.env[`_${key}`] ?? process.env[key],
  });
  if (envValue !== undefined) {
    return envValue;
  }

  return undefined;
}

export function setTerraConfigProvider<TConfigKey extends TerraConfigKey>(
  fn: ((key: TConfigKey) => string | undefined) | null,
): void {
  provider = fn as TerraConfigProvider | null;
}
